import {
  SelectProps as ChakraSelectProps,
  Flex,
  Text,
  Icon,
  Switch,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Tooltip, Select as BarteSelect } from "barte-design-system";

interface SelectProps extends ChakraSelectProps {
  name: string;
  label: string;
  register?: any;
  containerDisabled?: boolean;
  optionsList: any;
  defaultValue?: any;
  tooltipText?: string;
  errors?: any;
  hasSwitch?: boolean;
  switchActive?: boolean;
  setValue?: any;
  isDisabled?: boolean;
  hasInstallmentMix?: boolean;
  onChange?: any;
}

export function Select({
  name,
  label,
  register,
  containerDisabled = true,
  hasSwitch = false,
  setValue,
  switchActive,
  optionsList,
  tooltipText,
  errors,
  defaultValue,
  isDisabled,
  hasInstallmentMix,
  onChange,
  w,
  ...rest
}: SelectProps) {
  const [disabledState, setDisabledState] = useState(hasSwitch || containerDisabled);
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  function handleSwitchChange() {
    setDisabledState(!disabledState);
  }

  function handleSetDefaultInstallmentValue() {
    const defaultInstallment = {
      "installments": 10,
      "customInstallmentsValuesCreditCard": defaultValue || 10,
      "customInstallmentsValuesBankSlip": defaultValue || 1,
      "customInstallmentsValuesPix": defaultValue || 1
    }
    return defaultInstallment[name];
  }

  function handleBarteSelectChange(value: string) {
    setSelectedValue(value);
    register?.onChange?.({ target: { name, value } });
    onChange?.({ target: { name, value } });
  }

  useEffect(() => {
    setDisabledState(!switchActive);
  }, []);

  useEffect(() => {
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    if (disabledState && setValue) {
      setValue(name, handleSetDefaultInstallmentValue());
    }
  }, [disabledState]);

  return (
    <Flex flexDir="column" w={w || "100%"}>
      <Flex align="center" justify="space-between">
        <Flex align="center" marginRight={tooltipText ? ".2rem" : ""}>
          {label && (
            <Text
              marginRight={tooltipText ? ".2rem" : ""}
              marginBottom=".2rem"
              fontSize=".8rem"
              color={!containerDisabled ? "newGray.200" : "#000"}
              cursor={!containerDisabled && "not-allowed"}
            >
              {label}
            </Text>
          )}
          {tooltipText && (
            <Tooltip placement="top" label={tooltipText}>
              <span>
                <Icon w=".8rem" color="gray.400" as={AiOutlineInfoCircle} />
              </span>
            </Tooltip>
          )}
        </Flex>
        {hasSwitch && (
          <Switch
            name={name}
            isChecked={switchActive}
            defaultChecked={switchActive}
            onChange={handleSwitchChange}
            size="sm"
          />
        )}
      </Flex>
      <BarteSelect
        options={optionsList?.map((data) => ({
          label: hasInstallmentMix ? `até ${data?.title}` : data?.title,
          value: data?.value,
        }))}
        value={selectedValue}
        placeholder={label}
        disabled={!containerDisabled || (hasSwitch && disabledState) || isDisabled}
        onChange={handleBarteSelectChange}
      />
      {errors && (
        <Text fontSize=".8rem" color="danger" mb="4" role="alert">
          {errors.message}
        </Text>
      )}
    </Flex>
  );
}
